import { useContext, useEffect, useState } from "react";
import { Button } from "reactstrap";

import { default as utilIcons } from '../../resources/utilIcons';
import "../../styles/ValidationAdmin.css";

import { RestContext } from "../../App";
import { ADMIN_URL, VALIDATION_URL } from "../../serverConfig";
import { colors } from "../../styles/colors";


function ValidationAdmin({}) {
    const [allParameters, setAllParameters] = useState([]);
    const [scales, setScales] = useState([]);
    const [changed, setChanged] = useState(false);

    const { sendGetRequest, sendPostRequest } = useContext(RestContext);

    useEffect(() => {
        sendGetRequest(VALIDATION_URL + "/allParameters", (response) => {setAllParameters(response.data)});
        getScales();
    }, []);

    const getScales = () => {
        sendGetRequest(VALIDATION_URL + "/scales", (response) => {
            const responseData = response.data;
            const newScales = [];
            for (let [key, value] of Object.entries(responseData)) {
                newScales.push({parameter: key, min: value.min, max: value.max});
            }
            newScales.sort((a,b) => 
                a.parameter.localeCompare(b.parameter)
            );
            console.log(newScales);
            setScales(newScales);
            setChanged(false);
        });
    }

    const updateScale = (index, scale) => {
        const newScales = [...scales];
        newScales[index] = scale;
        setScales(newScales);
        setChanged(true);
    }

    const deleteScale = (index) => {
        const newScales = [...scales];
        newScales.splice(index, 1);
        setScales(newScales);
        setChanged(true);
    }

    const mapScales = () => {
        const usedParameters = new Set();
        for (let scale of scales) {
            usedParameters.add(scale.parameter);
        }
        const unusedParameters = allParameters.filter(parameter => !usedParameters.has(parameter));
        return scales.map((scale, index) => <ValidationScaleRow scale={scale} index={index} updateScale={updateScale} deleteScale={deleteScale} unusedParameters={unusedParameters}/>);
    }
    
    const mapParameters = () => {
        const usedParameters = new Set();
        for (let scale of scales) {
            usedParameters.add(scale.parameter);
        }
        const unusedParameters = allParameters.filter(parameter => !usedParameters.has(parameter));
        return ["Add new...", ...unusedParameters].map(parameter => <option>{parameter}</option>);
    }

    const saveScales = () => {
        sendPostRequest(ADMIN_URL + "/validation/scales", scales, (response) => {
            getScales();
        });
    }

    const handleNewSelect = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const value = event.target.value;
        event.target.value = "Add new...";
        const newScale = {parameter: value, min: 0, max: 100};
        const newScales = [...scales, newScale];
        setScales(newScales);
        setChanged(true);
    }

    return <div id="validation-admin">
        <div id="validation-scales-admin">
            <h3>Y Scales</h3>
            <div id="validation-scales-admin-table-wrapper">
                <table id="validation-scales-admin-table">
                    <thead><tr><th>Parameter</th><th>Min</th><th>Max</th></tr></thead>
                    <tbody>{mapScales()}
                        <tr><td><select value={null} onChange={handleNewSelect}>{mapParameters()}</select></td><td/><td/></tr>
                    </tbody>
                </table>
            </div>
            <Button id="validation-scales-admin-submit" className="submit-button" disabled={!changed} onClick={saveScales}>Save</Button>
        </div>
    </div>
}

function ValidationScaleRow({scale, index, unusedParameters, updateScale, deleteScale}) {
    const mapParameters = () => {
        if (!unusedParameters) return [];
        return [scale.parameter, ...unusedParameters].map(parameter => <option>{parameter}</option>);
    }

    const handleInput = (event) => {
        const {name, value} = event.target;
        const newScale = {...scale, [name]: value};
        updateScale(index, newScale);
    }

    const handleDelete = () => {
        deleteScale(index);
    }

    return <tr className="validation-admin-scale">
        <td><select name="parameter" value={scale.parameter} onChange={handleInput}>{mapParameters()}</select></td>
        <td><input name="min" type="number" value={scale.min} onChange={handleInput}/></td>
        <td><input name="max" type="number" value={scale.max} onChange={handleInput}/></td>
        <td><Button onClick={handleDelete}>{utilIcons.trash(colors['ars-neutral-900'])}</Button></td>
    </tr>
}

export default ValidationAdmin;